import React, { useEffect, createElement } from 'react';
import { NoviHeroInfo } from './novi/NoviHeroInfo';
import { NoviHeroForm } from './novi/NoviHeroForm';
import { NoviDistance } from './novi/NoviDistance';
import { NoviWhy } from './novi/NoviWhy';
import { NoviPrograms } from './novi/NoviPrograms';
import { NoviScheduleLocation } from './novi/NoviScheduleLocation';
import { NoviReviews } from './novi/NoviReviews';
import { NoviFAQHeader } from './novi/NoviFAQHeader';
import { NoviFAQQuestions } from './novi/NoviFAQQuestions';
import { NoviLinks } from './novi/NoviLinks';
import { NoviFinalCTA } from './novi/NoviFinalCTA';
export function Novi() {
  useEffect(() => {
    document.title = 'Martial Arts & Taekwondo Near Novi, MI | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Looking for martial arts near Novi, MI? Storm Taekwondo is just minutes away, offering kids and family classes that build confidence and focus. Try a free week.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Looking for martial arts near Novi, MI? Storm Taekwondo is just minutes away, offering kids and family classes that build confidence and focus. Try a free week.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2652">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2653">
        <div className="absolute inset-0 opacity-20" data-id="element-2654">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-2655" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2656" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2657">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2658">
            <NoviHeroInfo data-id="element-2659" />
            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2660">
              <NoviHeroForm data-id="element-2661" />
            </div>
          </div>
        </div>
      </section>

      <NoviDistance data-id="element-2662" />
      <NoviWhy data-id="element-2663" />
      <NoviPrograms data-id="element-2664" />
      <NoviScheduleLocation data-id="element-2665" />
      <NoviReviews data-id="element-2666" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-2667">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2668">
          <NoviFAQHeader data-id="element-2669" />
          <NoviFAQQuestions data-id="element-2670" />
        </div>
      </section>
      <NoviLinks data-id="element-2671" />
      <NoviFinalCTA data-id="element-2672" />
    </div>;
}